export class Question {
  factor1: number;
  factor2: number;
  sequenceNumber: number;

  constructor(factor1: number, factor2: number, sequenceNumber: number) {
    this.factor1 = factor1;
    this.factor2 = factor2;
    this.sequenceNumber = sequenceNumber;
  }
}
